import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faBook, faCircleQuestion, faCartShopping, faVideo } from '@fortawesome/free-solid-svg-icons';
import '../styles/sidebarProfile.css';

function SidebarProfile() {
  const menuItems = [
    { path: "/profile", name: "الملف الشخصي", icon: faHouse },
    { path: "/profile/courses", name: "الكورسات", icon: faBook },
    { path: "/profile/quiz", name: "نتائج الامتحانات", icon: faCircleQuestion },
    { path: "/profile/homeworks", name: "نتائج الواجبات", icon: faCircleQuestion },
    { path: "/profile/videos", name: "فيديوهات الواجبات", icon: faVideo },
    { path: "/profile/wallet", name: "الاشتراكات", icon: faCartShopping },
  ];

  return (
    <aside className="sidebar-profile-main">
      <nav className="sidebar-nav">
        <ul>
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink to={item.path} end={item.path === "/profile"}>
                <FontAwesomeIcon icon={item.icon} className="nav-icon" />
                <span className="nav-text">{item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}

export default SidebarProfile;
